<template></template>
<script>
export default {
    created(){
        let workspaceId = localStorage.getItem('workspaceId')
        localStorage.clear();
        location.href = `${process.env.VUE_APP_HOST_AUTHENTICATION}/logout?workspaceId=${workspaceId}`
    }
}
</script>
<style lang="scss" scoped>

</style>
